import {Component} from "react";
import logo from "./images/cena en rojo_cuadrado.svg";
import "./css/Landing.css"
     import {getPayments, showManual, showQR} from "./Actions";
import ManualRegister from "./ManualRegister";


export default class Landing extends Component {
    componentDidMount() {
        getPayments()
    }
    render() {
        return (
            <div className="landing">
                <ManualRegister/>
            </div>
        )
    }
}